/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// if(document.getElementById("tab-1") != null && document.getElementById("tab-1").lenth != 0){
// document.getElementById("tab-1").checked = true;
// }

// $('.banner-slider').slick({
//   speed: 500
// });
// jQuery(".carousel-cell img.sec_image").click(function(){
// jQuery(".carousel-cell img.sec_image").removeClass("colborder");
//     jQuery(this).addClass("colborder");
//   var srvalue = jQuery(this).attr("src");
//   jQuery(".collection__image.image--fade-in.lazyloaded").css({"background-image":"url("+srvalue+")"})
//   });


$(document).ready(function() {
//alert(customerID);
  if (typeof customerID !== 'undefined') {
    // Now you can use the customer ID in your jQuery code
    console.log('Logged in customer ID:', customerID);
    
    // You can make AJAX calls or other operations using the customer ID
  } else {
    console.log('No customer is logged in.');
  }

  $.getJSON('https://mtcrewards.com/get-customer-discount-code?customerId='+customerID, function(data) {
    // console.log(data.customer_id)
      // if(data.customer_id === customerID){
        var urlParams = new URLSearchParams(window.location.search);
        var discountCode = data.discount_code;
        console.log(discountCode)
        if (discountCode != '')  {
          // Save the discount code as a session cookie
          document.cookie = `discount_code=${discountCode}; path=/`;
          // Send GET request to "/discount/[discountcode]"
          fetch(`/discount/${discountCode}`)
          .then(function() {
        
            // After the discount code has been applied, force the cart to update so the discount is visible instantly
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                updates: {},
              }),
            });
          })
          .catch(function(error) {
            console.error('Error:', error);
          });
        }
        else{
           console.log("No Discount");
        }
  // }
    });

//getData();

// 28/11

$('#loyalty_screen_btn').on('click' , function(){
    // debugger;
var man_load = $(this).parents('.layout').find(' #previewContainer2');
console.log(man_load);
  var attribute_av = man_load.find('#previewFrame2').attr('src');
  // var rendom_load = $(this).parents('#current_plan_card_div').find('#discount_code');
  man_load.addClass('loading');
  // rendom_load.addClass('loading_ren');
setTimeout(function(){
   man_load.removeClass('loading');
  // rendom_load.removeClass('loading_ren');
}, 1000);
// if(attribute_av !== 'undefind' && attribute_av !== false){
//   man_load.addClass('loading');
// }else{
//     man_load.removeClass('loading');
// }
});

  
});

